export const environment = {
  production: true,
  baseURL: 'https://api.altiramacau.cn/api?key='
};
